export const createCountdown = (
  totalSeconds: number,
  setCountdownSeconds: (arg0: (arg0: number) => number) => any,
  endFunction: () => void
) => {
  const countdown = setInterval(() => {
    setCountdownSeconds((countdownSeconds) =>
      countdownSeconds > 0 ? countdownSeconds - 1 : 0
    )
  }, 1000)
  setTimeout(() => {
    clearInterval(countdown)
    endFunction()
  }, totalSeconds * 1000)
}

export const objToParams = (obj: Record<any, any>) => {
  const params = new URLSearchParams()
  for (const key in obj) {
    params.set(key, obj[key])
  }
  return params.toString()
}

export const capitalize = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1)
